module.exports = __webpack_public_path__ + "static/img/logo.weixin.05ae581.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.weixin.png
// module id = 1420
// module chunks = 382